import { useLocale, useT } from "@trust/i18n";

/**
 * 关于我们(P0.6):1:1 复刻旧站 views/inx/portal/about/index.vue。
 * 旧站引入过 Tailwind preflight(h1-h4/p/ul 默认样式被 reset,标题呈现为正文大小);
 * 本工程无 preflight,这里用显式 utility 补齐等价效果。外层 min-h + #f4f5f5 底由 PortalLayout 提供。
 */
const HEADING = "m-0 text-[1em] font-normal";
const NO_BULLETS = "m-0 list-none p-0";

export function AboutPage() {
  const t = useT();
  const locale = useLocale();

  return (
    <div className="mx-[300px] mt-[20px] bg-white px-[100px] pb-[50px] pt-[30px] max-portal:mx-4 max-portal:px-8">
      <h1 className={HEADING}>{t("inx.aboutUs.title")}</h1>
      <h3 className={HEADING}>{t("inx.aboutUs.subTitle")}</h3>
      <p className="m-0 text-[18px] leading-[30px]">{t("inx.aboutUs.p1")}</p>
      <p className="m-0 text-[18px] leading-[30px]">{t("inx.aboutUs.p2")}</p>
      <p className="m-0 text-[18px] leading-[30px]">{t("inx.aboutUs.p3")}</p>

      <div>
        <h3 className={HEADING}>{t("inx.aboutUs.evaluation.title")}</h3>
        <h4 className={HEADING}>{t("inx.aboutUs.evaluation.item1.title")}</h4>
        <ul className={NO_BULLETS}>
          <li>{t("inx.aboutUs.evaluation.item1.entry1")}</li>
        </ul>
        <h4 className={HEADING}>{t("inx.aboutUs.evaluation.item2.title")}</h4>
        <ul className={NO_BULLETS}>
          <li>{t("inx.aboutUs.evaluation.item2.entry1")}</li>
        </ul>
        <h4 className={HEADING}>{t("inx.aboutUs.evaluation.item3.title")}</h4>
        <ul className={NO_BULLETS}>
          <li>{t("inx.aboutUs.evaluation.item3.entry1")}</li>
          <li>{t("inx.aboutUs.evaluation.item3.entry2")}</li>
          <li>{t("inx.aboutUs.evaluation.item3.entry3")}</li>
          <li>{t("inx.aboutUs.evaluation.item3.entry4")}</li>
          <li>{t("inx.aboutUs.evaluation.item3.entry5")}</li>
        </ul>
        <h4 className={HEADING}>{t("inx.aboutUs.evaluation.item4.title")}</h4>
        <ul className={NO_BULLETS}>
          <li>{t("inx.aboutUs.evaluation.item4.entry1")}</li>
        </ul>
        <h4 className={HEADING}>{t("inx.aboutUs.evaluation.item5.title")}</h4>
        <ul className={NO_BULLETS}>
          <li>{t("inx.aboutUs.evaluation.item5.entry1")}</li>
          <li>{t("inx.aboutUs.evaluation.item5.entry2")}</li>
        </ul>
      </div>

      <div>
        <h3 className={HEADING}>{t("inx.aboutUs.evaluation.flow.title")}</h3>
        <p className="m-0">{t("inx.aboutUs.evaluation.flow.content")}</p>
        <div>
          {locale === "en" ? (
            <img
              src="/portal/evaluation_flow_imgs_en.png"
              alt={t("inx.aboutUs.evaluation.flow.title")}
              className="max-w-full"
            />
          ) : (
            <img
              src="/portal/evaluation_flow_imgs.jpg"
              alt={t("inx.aboutUs.evaluation.flow.title")}
              className="max-w-full"
            />
          )}
        </div>
      </div>

      <div className="whitespace-pre-wrap">
        <h2 className={HEADING}>{t("inx.aboutUs.privacyTitle")}</h2>
        <ul className={`${NO_BULLETS} text-[18px] leading-[26px]`}>
          <li>{t("inx.aboutUs.ul1")}</li>
          <li>{t("inx.aboutUs.ul1l1")}</li>
          <li>{t("inx.aboutUs.ul1l2")}</li>
          <li>{t("inx.aboutUs.ul1l3")}</li>
          <li>{t("inx.aboutUs.ul1l4")}</li>
          <br />
          <li>{t("inx.aboutUs.ul2")}</li>
          <li>{t("inx.aboutUs.ul2l1")}</li>
          <li>{t("inx.aboutUs.ul2l2")}</li>
          <ul className={NO_BULLETS}>
            <li>{t("inx.aboutUs.ul2l2l1")}</li>
            <li>{t("inx.aboutUs.ul2l2l2")}</li>
            <li>{t("inx.aboutUs.ul2l2l3")}</li>
            <li>{t("inx.aboutUs.ul2l2l4")}</li>
          </ul>
        </ul>
      </div>
    </div>
  );
}
